import "./Divider.css";

export default function Divider() {
  return <hr className="divider" />;
}
